import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToHero, scrollToSection } from "../lib/scroll";

/**
 * Scroll on route changes: hash sections on `/`, hero when landing on home without a hash.
 */
export default function ScrollToHash() {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    if (pathname !== "/") return undefined;

    const id = (hash || "").replace(/^#/, "").trim();

    const run = () => {
      if (id) scrollToSection(id);
      else scrollToHero();
    };

    const t = window.setTimeout(run, 0);
    return () => window.clearTimeout(t);
  }, [pathname, hash]);

  return null;
}
